import React from "react"

import styles from "./styles.module.styl"

import ExclamationIcon from "../../assets/svg/exclamationIcon.svg"

const InputIndexPage = props => {
	return (
		<div className={props.className || ""}>
			<input
				aria-label={props.inputAriaLablel}
				className={`
          ${props.className || ""}
          ${styles.input}
          ${props.invalidMessage ? styles.__invalid : ""}
       `}
				placeholder={props.placeholder}
				value={props.value}
				onChange={event => props.changeHandler(event.target.value)}
				{...props.extraProps}
			/>
			{props.invalidMessage && (
				<p className={styles.errorLabel}>
					<ExclamationIcon />
					{props.invalidMessage}
				</p>
			)}
		</div>
	)
}
export default InputIndexPage
